<template>
  <div id="app">
    <!-- 使用 transition 元素包裹路由出口 -->
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <audio preload autoplay loop id="music"></audio>
  </div>
</template>

<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import { getData } from "@/assets/device";
// 引入wxjs
import wx from "weixin-js-sdk";
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // getData();
    // this.$getShareInfo();
    // this.$getTxtData();
  },
  mounted() {
    this.$applyHeights();
    window.addEventListener("resize", this.handleResize);
    // 默认播放音频
    // this.playAudio();
    // 禁用右键菜单（图片长按）
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });

    // 禁用长按选中（文字、图片）
    document.addEventListener(
      "touchstart",
      function (e) {
        if (e.touches.length > 1) {
          e.preventDefault(); // 禁止多指触摸
        }
      },
      { passive: false }
    );

    document.addEventListener("gesturestart", function (e) {
      e.preventDefault(); // 禁止双指缩放
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
  },
};
</script>

<style scoped lang="less">
/* 定义fade过渡样式 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
